// Shared copy + query-param names for the QuickBooks/Xero OAuth result
// handling (CFO-22, S4). The five error codes are set by the backends'
// oauthCallback redirects — hardcoded there, so anything else in the URL
// falls back to the generic connection_failed copy.

export const QUICKBOOKS_SUCCESS_PARAM = 'quickbooks_connected_successfully';
export const XERO_SUCCESS_PARAM = 'xero_connected_successfully';
export const QUICKBOOKS_ERROR_PARAM = 'quickbooks_connect_error';
export const XERO_ERROR_PARAM = 'xero_connect_error';
export const CONNECTED_ELSEWHERE_PARAM = 'connected_elsewhere';
export const XERO_SELECT_ORG_PARAM = 'xero_select_org';

export type ConnectErrorCopy = {
  title: string;
  message: string;
};

export const connectErrorMessage = (
  code: string | null | undefined,
  providerName: string
): ConnectErrorCopy => {
  switch (code) {
    case 'consent_denied':
      return {
        title: 'Connection cancelled',
        message: `You cancelled the connection on the ${providerName} screen. Nothing was changed — you can connect again anytime.`,
      };
    case 'link_invalid':
      return {
        title: 'Connection failed',
        message:
          'This connection link is invalid or has expired. Nothing was connected — please start the connection again from this page.',
      };
    case 'permission_denied':
      return {
        title: 'Permission denied',
        message: `You don't have permission to connect ${providerName} to this project. Nothing was changed.`,
      };
    case 'provider_already_connected':
      return {
        title: 'Already connected',
        message: `This project was connected to an accounting system while the ${providerName} screen was open, so the new connection was not completed. A project can be connected to only one accounting system.`,
      };
    case 'connection_failed':
    default:
      return {
        title: 'Connection failed',
        message: `Something went wrong while connecting to ${providerName}. No connection was made — please try again.`,
      };
  }
};
